import React, {useState, useEffect} from 'react';
import {  Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import ArticlePartDatatable from './ArticlePartDatatable';


const ArticlePartModalWithDatatable = (props) => {
   
    const [t] = useTranslation();
    const [show, setShow] = useState(false);            
    const [bomId, setBomId] = useState(null);         
   // const [recordId, setRecordId ] = useState();    
  

    const handleCallback = (id) => {
        setShow(false);     
        props.parentCallback(false,id);      
    };
     
    const hideModal = () => {
      setShow(false);         
      props.parentCallback(false,'');      
    };
   
    useEffect(() => {
        setShow(props.modal);
    }, [props.modal])

    useEffect(() => {
      setBomId(props.bomId);
  }, [props.bomId])

    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                //  centered
                  size="lg"                       //xl                 
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{t('article.label.articles')}</Modal.Title>
                  </Modal.Header>
                    <Modal.Body>

                        <ArticlePartDatatable 
                          parentCallback={handleCallback}    
                          modalShow={show}
                          selectedRecord={bomId}   
                        />          
             
                    </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default ArticlePartModalWithDatatable;


 